import { createContext, useContext, useState, useEffect, useMemo } from 'react';

const DomainContext = createContext();

export function DomainProvider({ children }) {
  const [domain, setDomain] = useState(() => {
    return sessionStorage.getItem('selectedDomain') || 'greenyourbills.com';
  });

  useEffect(() => {
    //sessionStorage.setItem('selectedDomain', domain);
  }, [domain]);

  const value = useMemo(() => ({ domain, setDomain }), [domain]);

  return (
    <DomainContext.Provider value={value}>
      {children}
    </DomainContext.Provider>
  );
}

export const useCurrentDomain = () => {
  const context = useContext(DomainContext);
  if (!context) {
    throw new Error('useCurrentDomain must be used within DomainProvider');
  }
  return context;
};